package fr.manyverse.app.presentation.components.gm_screen

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.AlertType
import fr.manyverse.app.domain.model.EventContent
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.alert_gm_dismiss
import manyverse.shared.generated.resources.alert_gm_inappropriate
import manyverse.shared.generated.resources.alert_gm_player_message
import manyverse.shared.generated.resources.alert_gm_uncomfortable
import manyverse.shared.generated.resources.security_alert
import org.jetbrains.compose.resources.stringResource

@Composable
fun PlayerAlertGmOverlay(
    alert: EventContent.PlayerAlert,
    onDismiss: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.tertiaryContainer.copy(alpha = 0.97f))
            .statusBarsPadding(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp),
            modifier = Modifier.padding(32.dp)
        ) {
            Icon(
                imageVector = Icons.Default.Warning,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onTertiaryContainer,
                modifier = Modifier.size(64.dp)
            )
            Text(
                text = stringResource(Res.string.security_alert),
                style = MaterialTheme.typography.headlineSmall,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.onTertiaryContainer,
                textAlign = TextAlign.Center
            )
            val message = when (alert.alertType) {
                AlertType.UNCOMFORTABLE -> stringResource(
                    Res.string.alert_gm_uncomfortable,
                    alert.characterName
                )

                AlertType.INAPPROPRIATE -> stringResource(
                    Res.string.alert_gm_inappropriate,
                    alert.characterName
                )
            }
            Text(
                text = message,
                style = MaterialTheme.typography.bodyLarge,
                color = MaterialTheme.colorScheme.onTertiaryContainer,
                textAlign = TextAlign.Center
            )
            alert.message?.takeIf { it.isNotBlank() }?.let { playerMessage ->
                Text(
                    text = stringResource(Res.string.alert_gm_player_message, playerMessage),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                    textAlign = TextAlign.Center
                )
            }
            Spacer(Modifier.height(8.dp))
            Button(
                onClick = onDismiss,
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.onTertiaryContainer,
                    contentColor = MaterialTheme.colorScheme.tertiaryContainer
                )
            ) {
                Text(stringResource(Res.string.alert_gm_dismiss))
            }
        }
    }
}
